import styled from 'styled-components';

export const HorizontalLine = styled.hr`
  border-top: 1px solid rgba(0, 0, 0, 0.3);
`;
